<template>
  <div>
    <iframe src="" name="iFrameUserManagement" id="iFrameUserManagement" class="center-screen ele-hidden"></iframe>
    <header class="shop__header">
      <nav class="shop__header--navi">
        <div class="navi--container">
          <div class="shop__header--owayo" v-if="!inIFrame()">{{ shopinfo.anzeigeName }}</div>
          <!--<div class="shop__header--owayo">{{$t("shop_owayoTeamshop")}}</div>-->
          <div class="shop__header--navi--btns">
            <AdminMenu v-if="isOwner" :isOwner="isOwner"/>
            <div class="shoppingcart-component">
              <ShopMenue
                  :username="username"
                  :shoppingcart="shoppingcart"
                  :loggedin="loggedIn"
                  :shopName="shopinfo.shopName"
                  :language="language"
                  :land="land"
                  :warenkorbPositionen="anzWarenkorbPositionen"
                  @open_component_request="openComponentRequest"
              />
            </div>
          </div>
        </div>
      </nav>
      <div class="shop__header--bg" v-if="!inIFrame()"> <!--:class="shopinfo.theme"  -->
        <div class="shop__img--wrapper" :style="{ backgroundImage: 'url(' + getTitelBild + ')' }">
        </div>
        <div v-if="isOwner" class="shop__button--edit icon edit__shop--profile" @click="togglePopupEditTheme"></div>
        <div class="shop__header--logo">
          <div v-if="isOwner" class="edit__shop--logo" @click="togglePopupEditLogo">
            <div class="shop__button--edit icon image"></div>
          </div>
          <NuxtLink class="breadcrumb--link" :to="getRouteToHome()">
            <img :src="shoplogo" :alt="shopinfo.shopName"/>
          </NuxtLink>
        </div>
      </div>
    </header>
  </div>
</template>

<script lang="ts">

import {computed, type PropType} from "vue";
import { ref, reactive, watch } from 'vue';
//@ts-ignore
import {useStore} from "vuex";
//@ts-ignore
import {NavigationOpenRequestTypeFromShoppingcartMenu} from "owayo_menu";

import AdminMenu from "~/components/AdminMenu.vue";

import {PopupNames, PopupStatus} from "~/components/PopupHandler";

import {getRouteToHome} from "~/_router/routeUtils";
import {useFooterStore} from "~/store/FooterStore";
import type {ShopInfo} from "~/store/shopInfosStore";
import {Navigation_opencomponentHandler_SHOP} from "~/navigation_opencomponentHandler_SHOP";
import {insertCloudflareDownscalingIntoURL, insertCloudflareAutoformatIntoURL} from "@k/global/globalUtils";

export default {
  name: "ShopHeader",
  components: {
    AdminMenu,
  },
  props: {
    shopinfo: Object as PropType<ShopInfo>,
    isOwner: Boolean
  },
  setup(props) {
    const vuexStore = useStore();
    const route = useRoute();

    function inIFrame(){
      try {
        return (window.self !== window.top) || route.query.display === "iframe";
      } catch (e) {
        return false;
      }
    }

    function togglePopupEditTheme() {
      PopupStatus.TOGGLE_POPUP(PopupNames.editTheme);
    }

    function togglePopupEditLogo() {
      PopupStatus.TOGGLE_POPUP(PopupNames.editLogo);
    }

    const footerstore = useFooterStore();


    return {
      username: computed(() => vuexStore.getters.getUsername),
      shoppingcart: computed(() => vuexStore.getters.getWarenkorbPos),
      loggedIn: computed(() => vuexStore.getters.isLoggedIn || false),
      shoplogo: computed(() => insertCloudflareDownscalingIntoURL(props.shopinfo?.shopLogoPath || "", 160, 160)),
      openComponentRequest: (component: NavigationOpenRequestTypeFromShoppingcartMenu) => Navigation_opencomponentHandler_SHOP.open_component(component),
      logout: () => Navigation_opencomponentHandler_SHOP.open_component(NavigationOpenRequestTypeFromShoppingcartMenu.logout),
      togglePopupEditTheme,
      togglePopupEditLogo,
      inIFrame,
      getRouteToHome,
      language: computed(() => footerstore.getLanguage),
      land: computed(() => footerstore.getLand),
      anzWarenkorbPositionen: computed(() => vuexStore.getters.getAnzWarenkorbPositionen),
      getTitelBild: computed(() => props.shopinfo?.themeBgImage.includes("owayo-cdn.com") ? insertCloudflareAutoformatIntoURL(props.shopinfo?.themeBgImage) : props.shopinfo?.themeBgImage.replace(".jpg", ".webp"))
    }
  }
}
</script>


<style lang="scss">

@use "~/assets/scss/settings/_config.scss" as *;

#iFrameUserManagement {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: rgba(black, .4);
  z-index: 9999;

  &.center-screen {
    margin: 0;
    transform: translate(0, 0);
  }
}

.shop__header--navi {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 99;
  background: white;
  height: 60px;
  border-bottom: 1px solid #f5f5f5;
}

.navi--container {
  width: $shop-content;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .shop__header--owayo {
    font-size: 14px;
    font-weight: 600;
    color: $color-black;
    display: block;
    max-width: 40%;

    @media (max-width: 550px) {
      max-width: 50%;
    }
  }

  .shop__header--navi--btns {
    display: flex;

    .shoppingcart-component {
      position: relative;
      width: 100px;
      display: flex;

      .km__button--icon.account {
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBpZD0iTG9naW4tSWNvbiIgd2lkdGg9IjIyLjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyMi41IDI1Ij4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoIj4KICAgICAgPHJlY3QgaWQ9IlJlY2h0ZWNrXzgzMiIgZGF0YS1uYW1lPSJSZWNodGVjayA4MzIiIHdpZHRoPSIyMi41IiBoZWlnaHQ9IjI1IiBmaWxsPSJub25lIj48L3JlY3Q+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KICA8ZyBpZD0iR3J1cHBlXzc0NiIgZGF0YS1uYW1lPSJHcnVwcGUgNzQ2IiBjbGlwLXBhdGg9InVybCgjY2xpcC1wYXRoKSI+CiAgICA8cGF0aCBpZD0iUGZhZF8xMTYzIiBkYXRhLW5hbWU9IlBmYWQgMTE2MyIgZD0iTTExLjI1LDE2LjAwOWE3LjU4Miw3LjU4MiwwLDAsMSwyLjYxNS40NjRsNS45MDgsMi4xNjQuNDMsNC4yNjhIMi4zbC40My00LjI2OCw1LjkwNy0yLjE2NGE3LjU4Miw3LjU4MiwwLDAsMSwyLjYxNS0uNDY0bTAtMi4xYTkuNjY1LDkuNjY1LDAsMCwwLTMuMzIzLjU5TC43OTQsMTcuMTE2LjY2OCwxOC4zNjIuMjMyLDIyLjY5MywwLDI1SDIyLjVsLS4yMzItMi4zMDctLjQzNi00LjMzLS4xMjUtMS4yNDdMMTQuNTczLDE0LjVhOS42NjUsOS42NjUsMCwwLDAtMy4zMjMtLjU5IiBmaWxsPSIjMjQyNDI0Ij48L3BhdGg+CiAgICA8cGF0aCBpZD0iUGZhZF8xMTY0IiBkYXRhLW5hbWU9IlBmYWQgMTE2NCIgZD0iTTExLjI1LDIuMUEzLjcwOCwzLjcwOCwwLDEsMSw3LjU0Miw1LjgsMy43MTIsMy43MTIsMCwwLDEsMTEuMjUsMi4xbTAtMi4xYTUuOCw1LjgsMCwxLDAsNS44LDUuOEE1LjgsNS44LDAsMCwwLDExLjI1LDAiIGZpbGw9IiMyNDI0MjQiPjwvcGF0aD4KICA8L2c+Cjwvc3ZnPgo=);
        background-size: 22px;
        opacity: 1;
        right: 0;
        position: relative;
      }

      .km__button--icon.shoppingcart {
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi41NTEiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyMi41NTEgMjUiPgogIDxwYXRoIGlkPSJQZmFkXzExNDAiIGRhdGEtbmFtZT0iUGZhZCAxMTQwIiBkPSJNMzQ5LjIzOCwyNDcuNTUzdi0uNDY4YTUuMDg1LDUuMDg1LDAsMSwwLTEwLjE2OSwwdi40NjhoLTYuMTgxVjI2N2gyMi41NTFWMjQ3LjU1M1ptLTguMDc2LS40NjhhMi45OTIsMi45OTIsMCwwLDEsNS45ODQsMHYuNDY4aC01Ljk4NFptMTIuMTgzLDE3LjgySDMzNC45ODJWMjQ5LjY0OGg0LjA4NnYzLjMxM2gyLjA5M3YtMy4zMTNoNS45ODR2My4zMTNoMi4wOTJ2LTMuMzEzaDQuMTA3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzMi44ODggLTI0MikiIGZpbGw9IiMyNDI0MjQiPjwvcGF0aD4KPC9zdmc+Cg==);
        background-size: 22px;
        background-color: transparent;
        opacity: 1;
        right: 0;
        position: relative;
      }

      .km__navi--shoppingcart {
        position: fixed;
        right: 0;
        z-index: 99;
        /*top: $header-height;*/
        width: 100%;
        height: 100%;
        display: flex;
        overflow-x: scroll;

        /*max-width: 400px;*/

        @media(min-width: 600px) {
          //transform: translateX(400px);
          width: 400px;
          top: 60px;
        }
      }


      .km__navi__heading_shoppingcart {
        color: $color-blue;
        text-align: center;
        padding-top: 30px;
        margin-bottom: 10px;
        font-size: 14px;
      }

      .km__button--link {
        &.user--orders,
        &.user--account,
        &.user--login,
        &.user--logout,
        &.checkout {
          text-align: center;
          padding: 15px 0;
        }
      }

      .km__button--standard {
        &.checkout {
          border: none;
          width: 140px;
          height: 40px;
          background-color: $color-blue;
          color: $color-white;
          margin: 0 auto;
        }
      }

      .km__shoppingcart--logout {
        padding: 15px 0;
        /*border-bottom: 1px solid $color-blue;*/
        text-align: center;
      }

      .km__navi__submenu__shoppingcart {
        position: relative;
        background: $color-white;
        padding: 0 20px;
        border-bottom: 1px solid $color-blue;

        .km__list__element {
          &:last-child {
            padding-top: 20px;
            padding-bottom: 20px;
          }
        }
      }

      .km__navi--content-wrapper {
        background: rgba(239, 239, 239, 1.0);
        width: calc(100% - 60px);
        height: 100%;
        box-shadow: 2px 2px 15px #969696;
      }

      .km__navi--close-wrapper {
        width: 60px;
        height: 100%;

        .km__navi--close {
          background-position: center;
          background-repeat: no-repeat;
          background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojMzMzMzMzO3N0cm9rZS13aWR0aDo3LjY4MzI7c3Ryb2tlLWxpbmVjYXA6c3F1YXJlO3N0cm9rZS1taXRlcmxpbWl0OjEwO30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPGc+DQoJCQk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMjUuNSIgeTE9Ijc0LjUiIHgyPSI3NC41IiB5Mj0iMjUuNSIvPg0KCQk8L2c+DQoJPC9nPg0KCTxnPg0KCQk8Zz4NCgkJCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIyNS41IiB5MT0iMjUuNSIgeDI9Ijc0LjUiIHkyPSI3NC41Ii8+DQoJCTwvZz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg==');
          background-size: 35px;
          width: 60px;
          height: 60px;
          margin: 8px auto;
          background-color: white;
        }
      }

      .km__list--modules {
        &.shoppingcart--preview {
          padding: 15px 0 20px 0;
          border-bottom: 1px solid #dfdfdf;

          .km__shoppingcart--previe--wrapper {
            display: flex;
            flex-direction: row;
            column-gap: 20px;
            margin-bottom: 20px;
          }
        }
      }

      .km__navi__shoppingcart--preview {
        width: 50%;
        padding: 0 10px;
      }

      .km__navi__shoppingcart--content {
        text-align: left;
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
}

.shop__header--bg {
  top: 60px;
  position: relative;

  .shop__header--logo {
    position: absolute;
    width: 160px;
    height: 160px;
    left: 120px;
    bottom: -60px;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    border-radius: 100%;
    border: 5px solid white;
    background: $color-stage-bg;
    padding: 15px;
    font-family: "owayoFont", Arial, Verdana, Helvetica, sans-serif;

    @media (max-width: 1100px) {
      left: 50%;
      margin-left: -80px;
    }

    .edit__shop--logo {
      position: absolute;
      right: -10px;
      bottom: 15px;
      z-index: 9;
    }

    img {
      clip-path: circle(74px at center);
    }
  }

  .edit__shop--profile {
    position: absolute;
    right: 120px;
    bottom: 20px;

    @media (max-width: 800px) {
      right: 20px;
    }
  }
}

.shop__img--wrapper {
  position: relative;
  width: 100%;
  height: 300px;
  background-color: $color-stage-bg;
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}


</style>

